import { EventStatus, QuoteStatus } from '../types/index.js';
export const EVENT_STATUS_LABELS = {
    [EventStatus.DRAFT]: 'Draft',
    [EventStatus.PLANNING]: 'Planning',
    [EventStatus.CONFIRMED]: 'Confirmed',
    [EventStatus.IN_PROGRESS]: 'In Progress',
    [EventStatus.COMPLETED]: 'Completed',
    [EventStatus.CANCELLED]: 'Cancelled',
};
export const QUOTE_STATUS_LABELS = {
    [QuoteStatus.REQUESTED]: 'Requested',
    [QuoteStatus.RECEIVED]: 'Received',
    [QuoteStatus.ACCEPTED]: 'Accepted',
    [QuoteStatus.DECLINED]: 'Declined',
    [QuoteStatus.WITHDRAWN]: 'Withdrawn',
};
//# sourceMappingURL=statuses.js.map